import { html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import componentStyle from '../common/styles/Component.css'
import style from './TopBar.css'

/**
 * Top bar is a header component that is always visible at the top of the interface. Top bar allows functionality such as search and contextual menus to be placed at the top of the interface.
 *
 * @status ready
 * @category structure
 * @slot - Used for the main content of the top bar. We recommend placing your application’s global search functionality into this slot.
 * @slot end - Optional slot for menus, buttons, toggles, etc.
 */
@customElement('nord-top-bar')
export default class TopBar extends LitElement {
  static styles = [componentStyle, style]

  render() {
    return html`
      <slot></slot>
      <slot name="end"></slot>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-top-bar': TopBar
  }
}
